import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MockupShowcase } from './components/MockupShowcase';
import { ProductOverview } from './components/ProductOverview';
import { ClassDemo } from './components/ClassDemo';
import { LaunchOffer } from './components/LaunchOffer';
import { BeforeAfter } from './components/BeforeAfter';
import { Bonuses } from './components/Bonuses';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function App() {
  // Meta Pixel
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const f: any = window;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) target.appendChild(script);
      window.fbq?.('init', '3123699361155808');
      window.fbq?.('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel could not be loaded:', err);
    }
  }, []);
  return <div className="min-h-screen bg-background text-white selection:bg-primary selection:text-black" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        {/* SECCIÓN 1 - HERO */}
        <Hero data-id="element-3" />

        {/* SECCIÓN 2 - PROBLEMA (movido arriba) */}
        <PainPoints data-id="element-4" />

        {/* SECCIÓN 3 - MOCKUP PREMIUM */}
        <MockupShowcase data-id="element-5" />

        {/* SECCIÓN 4 - ¿QUÉ RECIBÍS EXACTAMENTE? */}
        <ProductOverview data-id="element-6" />

        {/* SECCIÓN 5 - DEMOSTRACIÓN REAL */}
        <ClassDemo data-id="element-7" />

        {/* SECCIÓN 6 - PRECIO (después de la clase real) */}
        <LaunchOffer data-id="element-8" />

        {/* SECCIÓN 7 - TRANSFORMACIÓN */}
        <BeforeAfter data-id="element-9" />

        {/* SECCIÓN 8 - BONOS */}
        <Bonuses data-id="element-10" />

        {/* SECCIÓN 9 - PRUEBA SOCIAL */}
        <SocialProof data-id="element-11" />

        {/* SECCIÓN 10 - OFERTA */}
        <Pricing data-id="element-12" />

        {/* SECCIÓN 11 - GARANTÍA */}
        <Guarantee data-id="element-13" />

        {/* SECCIÓN 12 - FAQ */}
        <FAQ data-id="element-14" />

        {/* SECCIÓN 13 - CTA FINAL */}
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />

      {/* Floating */}
      <PurchaseNotification data-id="element-17" />
      <StickyMobileCTA data-id="element-18" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-19">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-20" />
      </noscript>
    </div>;
}